export const normalImportanceMenuText = "Fms13d";
export default {normalImportanceMenuText};